import {
  Badge,
  Box,
  Heading,
  HStack,
  Icon,
  Text,
  VStack,
  useColorModeValue,
} from "@chakra-ui/react";
import { FiCalendar, FiClock } from "react-icons/fi";
import { News } from "../../types";
import {
  formatNewsDate,
  formatNewsTime,
  getNewsCategoryMeta,
  getNewsImage,
} from "../../utils/news";

interface NewsCardProps {
  item: News;
  onClick: () => void;
}

export const NewsCard = ({ item, onClick }: NewsCardProps) => {
  const category = getNewsCategoryMeta(item.category);
  const cardBg = useColorModeValue("white", "dark.50");
  const textColor = useColorModeValue("gray.800", "white");
  const subtitleColor = useColorModeValue("gray.600", "gray.400");
  const borderColor = useColorModeValue("gray.100", "gray.700");
  const timeLabel = formatNewsTime(item.createdAt);

  return (
    <Box
      bg={cardBg}
      borderRadius="2xl"
      overflow="hidden"
      border="1px solid"
      borderColor={borderColor}
      cursor="pointer"
      onClick={onClick}
      _hover={{ shadow: "xl", transform: "translateY(-4px)" }}
      transition="all 0.3s"
      h="100%"
    >
      <Box
        w="100%"
        aspectRatio={16 / 9}
        bgImage={`url(${getNewsImage(item)})`}
        bgSize="cover"
        bgPosition="center"
      />
      <VStack align="stretch" spacing={4} p={6}>
        <HStack justify="space-between" align="start">
          <Badge colorScheme={category?.accentColor ?? "brand"}>
            {category?.title ?? item.category}
          </Badge>
          {item.isFeatured ? <Badge variant="subtle">منتخب</Badge> : null}
        </HStack>
        <Heading as="h3" fontSize="lg" color={textColor} noOfLines={2}>
          {item.title}
        </Heading>
        <Text color={subtitleColor} fontSize="sm" lineHeight="1.9" noOfLines={3}>
          {item.excerpt || item.content}
        </Text>
        <HStack justify="space-between" color={subtitleColor} fontSize="xs">
          <HStack spacing={1}>
            <Icon verticalAlign="middle" as={FiCalendar as any} />
            <Text>{formatNewsDate(item.createdAt)}</Text>
          </HStack>
          {timeLabel ? (
            <HStack spacing={1}>
              <Icon verticalAlign="middle" as={FiClock as any} />
              <Text>{timeLabel}</Text>
            </HStack>
          ) : null}
        </HStack>
      </VStack>
    </Box>
  );
};
